import React from 'react'
import { View } from 'react-native'
import FastImage, { ImageStyle } from 'react-native-fast-image'
import { useSelector } from 'react-redux'
import { useTheme } from '@ui-kitten/components'
import { Text } from '@components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { userSelector } from '@src/selectors/app'
import { useUserInitials } from '@src/utils/hooks'
import { useIsDarkMode } from '@src/config/theme'

export const UserAvatar = () => {
  const styles = useStyleSheet(themedStyle)
  const { avatar } = useSelector(userSelector) ?? {}
  const initials = useUserInitials()
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()

  return avatar ? (
    <FastImage style={styles.avatar as ImageStyle} source={{ uri: avatar }} />
  ) : (
    <View
      style={[
        styles.initialsContainer,
        {
          backgroundColor: isDarkMode ? theme['theme.accent.brick'] : theme['theme.accent.citron'],
        },
      ]}
    >
      <Text type="regular" bold style={styles.initials}>
        {initials}
      </Text>
    </View>
  )
}

const themedStyle = StyleService.create({
  initialsContainer: {
    width: '100%',
    height: '100%',
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    height: '100%',
    width: '100%',
    borderRadius: 100,
  },
  initials: {
    color: 'theme.primary.dark',
  },
})
